import classnames from 'classnames';
import React from 'react';

interface Props {
  components: React.ReactNode[];
}

class ButtonGroupOverlay extends React.Component<Props> {
  containerRef: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);

    this.containerRef = React.createRef();
  }

  componentDidMount(): void {
    this.forceUpdate();
  }

  render(): React.ReactNode {
    const { components } = this.props;

    const containerEl = this.containerRef.current;

    const width = containerEl ? containerEl.clientWidth : 0;

    return (
      <div
        ref={this.containerRef}
        className="bgd-primary flex items-center"
        style={{
          position: 'fixed',
          top: '16px',
          height: '48px',
          left: `calc(50vw - ${width / 2}px)`,
          borderRadius: '4px',
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
          padding: '.75rem',
        }}
      >
        <div className="row color-white items-center h100 w100">
          {components.map(
            (component: React.ReactNode, i: number): React.ReactNode => (
              <div
                key={i} // eslint-disable-line
                className={classnames('h100 row flex-center grow-1 py2 px4', {
                  'bl-solid bl-white bl-width-1': i > 0,
                })}
              >
                {component}
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

export default ButtonGroupOverlay;
